import React from "react";
import DeepScalperImage from "../assets/DeepScalper.jpg";
import KDD23 from "../assets/KDD23.jpg";
import RPRUDEXCompassImage from "../assets/RPRUDEX-Compass.png";
import wealthGraphImage from "../assets/wealthGraph.jpg";
import surveyImage from "../assets/surveyImage.jpg";
import externalLinkIcon from "../assets/icons8-external-link.svg";
import RL4QT from "../assets/RL4QT.jpg";
import "../styles/Research.css";
import EarnHFTPipline from "../assets/EarnHFT_training_pipline.png";
import month_record_1 from "../assets/month_record_-1.png";
import month_record_2 from "../assets/month_record_-2.png";
import month_record_3 from "../assets/month_record_-3.png";
import month_record_4 from "../assets/month_record_-4.png";
import strategy_1 from '../assets/strategy_-1.pkl';
import strategy_2 from '../assets/strategy_-2.pkl';
import strategy_3 from '../assets/strategy_-3.pkl';
import strategy_4 from '../assets/strategy_-4.pkl';

export default function EarnHFT() {
    return (
        <div>
            <div className="aa">
                <div className="topa">
                <div className="form-floating">
                    <h3 style={{ fontSize: "42px", textAlign: "center", fontWeight: 700 }}>
                        EarnHFT: RL Based Algorithm for HFT in Crypto Market
                    </h3>
                </div>

                <br />
                <h5 style={{ fontSize: "30px", textAlign: "justify", fontWeight: 300 }}>

                    EarnHFT utilizes a hierarchical <strong>reinforcement learning</strong> framework for efficient <strong>high-frequency trading</strong> in the <strong>cryptocurrency</strong> market.
                    Please refer to the <strong><a
                        href="https://arxiv.org/abs/2309.12891"
                        style={{ textDecoration: "underline" }}
                        target="_blank"
                    >
                        EarnHFT paper </a></strong>for more information.


                </h5>
                <br />
                <img src={EarnHFTPipline} alt="EarnHFT pipeline" className="img-fluid" />
                </div>
            </div>
            <div className='container' style={{marginTop:'70px'}}>
                
                <h3 className='History'>
                    The History Net Curve of EarnHFT
                </h3>
                <br />
                <h3 style={{ fontSize: "30px", textAlign: "center", fontWeight: 300 }}>
                    The model is trained on the data from <strong>Sep 01 to Sep 27 2022</strong><br />
                    evaluated under <strong>0 commission fee</strong> in <strong>2023</strong><br />
                    with the <strong>BTCUSDT spot</strong> trading pair from <strong>Binance</strong> and a capacity of <strong>300 SGD</strong>.
                </h3>

                <br />
                {/*<div className="grid-container">*/}
                {/*    <h3 style={{ fontSize: "30px", textAlign: "center", fontWeight: 600 }}>*/}
                {/*        The result is calculated using the BTCUSDT spot trading pair from Binance, under 0 commission fee*/}
                {/*    </h3>*/}
                {/*    <img src={month_record_1} alt="month_record_1" className="img-fluid" />*/}
                {/*    <br />*/}
                {/*    <h3 style={{ fontSize: "38px", textAlign: "center", fontWeight: 700 }}>*/}
                {/*        <a href={strategy_1}  download="strategy_-1.pkl" style={{ color: "blue", textDecoration: "underline" }}>*/}
                {/*            Download Strategy 1*/}
                {/*        </a>*/}
                {/*    </h3>*/}
                {/*    <br />*/}
                {/*    <img src={month_record_2} alt="month_record_2" className="img-fluid" />*/}
                {/*    <br />*/}
                {/*    <h3 style={{ fontSize: "38px", textAlign: "center", fontWeight: 700 }}>*/}
                {/*        <a href={strategy_2} download="strategy_-2.pkl" style={{ color: "blue", textDecoration: "underline" }}>*/}
                {/*            Download Strategy 2*/}
                {/*        </a>*/}
                {/*    </h3>*/}
                {/*    <br />*/}
                {/*    <img src={month_record_3} alt="month_record_3" className="img-fluid" />*/}
                {/*    <br />*/}
                {/*    <h3 style={{ fontSize: "38px", textAlign: "center", fontWeight: 700 }}>*/}
                {/*        <a href={strategy_3} download="strategy_-3.pkl" style={{ color: "blue", textDecoration: "underline" }}>*/}
                {/*            Download Strategy 3*/}
                {/*        </a>*/}
                {/*    </h3>*/}
                {/*    <br />*/}
                {/*    <img src={month_record_4} alt="month_record_4" className="img-fluid" />*/}
                {/*    <br />*/}
                {/*    <h3 style={{ fontSize: "38px", textAlign: "center", fontWeight: 700 }}>*/}
                {/*        <a href={strategy_4} download="strategy_-4.pkl" style={{ color: "blue", textDecoration: "underline" }}>*/}
                {/*            Download Strategy 4*/}
                {/*        </a>*/}
                {/*    </h3>*/}
                {/*</div>*/}
                <div className="grid-container">
                    <div>
                        <img src={month_record_1} alt="month_record_1" className="img-fluid" />
                        <h3 style={{ fontSize: "30px", textAlign: "center", fontWeight: 700 }}>
                            <a className="lianjie" href={strategy_1} download="strategy_-1.pkl" style={{ color: "blue", }}>
                                Download History Transaction
                            </a>
                        </h3>
                    </div>

                    <div>
                        <img src={month_record_2} alt="month_record_2" className="img-fluid" />
                        <h3 style={{ fontSize: "30px", textAlign: "center", fontWeight: 700 }}>
                            <a className="lianjie"  href={strategy_2} download="strategy_-2.pkl" style={{ color: "blue",  }}>
                                Download History Transaction
                            </a>
                        </h3>
                    </div>

                    <div>
                        <img src={month_record_3} alt="month_record_3" className="img-fluid" />
                        <h3 style={{ fontSize: "30px", textAlign: "center", fontWeight: 700 }}>
                            <a className="lianjie"  href={strategy_3} download="strategy_-3.pkl" style={{ color: "blue",  }}>
                                Download History Transaction
                            </a>
                        </h3>
                    </div>

                    <div>
                        <img src={month_record_4} alt="month_record_4" className="img-fluid" />
                        <h3 style={{ fontSize: "30px", textAlign: "center", fontWeight: 700 }}>
                            <a className="lianjie"   href={strategy_4} download="strategy_-4.pkl" style={{ color: "blue" }}>
                                Download History Transaction
                            </a>
                        </h3>
                    </div>
                </div>








            </div>
        </div>
    );
}
